import { Typography, TypographyProps, alpha, Box, BoxProps } from '@mui/material';

import { combineStyles, typedStyles } from '@/utils/styleUtils';

import { InfoIcon } from '@/components/icons/InfoIcon';

import type { Override } from '@/types/common';

import { colors } from '@/themesConfig/colors';

type TInfoBoxProps = Override<
  BoxProps,
  {
    color?: 'grey' | 'blue';
    variant?: TypographyProps['variant'];
  }
>;

const styles = typedStyles({
  root: ({ spacing }) => ({
    display: 'flex',
    width: '100%',
    padding: spacing(2, 3),
    gap: spacing(2),
    borderRadius: 2,

    '.MuiTypography-root': {
      alignSelf: 'center',
    },

    '.MuiTypography-body2': {
      lineHeight: '20px',
    },
  }),

  grey: {
    backgroundColor: 'custom.contrast.6',
  },

  blue: {
    backgroundColor: alpha(colors.brandBlue, 0.1),
    color: colors.brandBlue,
  },
});

export const InfoBox = ({
  children,
  sx,
  color = 'grey',
  variant = 'caption',
  ...props
}: TInfoBoxProps) => {
  const typographyColors = {
    grey: 'text.disabled',
    blue: 'custom.contrast.1',
  };

  return (
    <Box sx={combineStyles(styles.root, styles[color], sx)} {...props}>
      <InfoIcon />

      <Typography variant={variant} color={typographyColors[color]}>
        {children}
      </Typography>
    </Box>
  );
};
